import type { AppData, AppointmentStatus, ServiceType } from "../types";

function isoAt(now: Date, dayOffset: number, hour: number, minute: number, durationMinutes: number) {
  const start = new Date(now);
  start.setHours(hour, minute, 0, 0);
  start.setDate(start.getDate() + dayOffset);
  const end = new Date(start.getTime() + durationMinutes * 60_000);
  return { startsAt: start.toISOString(), endsAt: end.toISOString() };
}

function appointment(
  now: Date,
  id: string,
  petId: string,
  dayOffset: number,
  hour: number,
  minute: number,
  durationMinutes: number,
  status: AppointmentStatus,
  serviceType: ServiceType,
  servicePricePln?: number,
  notes?: string,
  customServiceName?: string,
) {
  return {
    id,
    petId,
    ...isoAt(now, dayOffset, hour, minute, durationMinutes),
    status,
    serviceType,
    servicePricePln,
    notes,
    customServiceName,
  };
}

export function createSeedData(now: Date): AppData {
  return {
    owners: [
      { id: "owner-anna", fullName: "Anna Jarocińska", phone: "+48 501 204 091", email: "anna.jarocinska@example.com" },
      { id: "owner-jan", fullName: "Jan Kowalski", phone: "+48 502 110 213", email: "jan.kowalski@example.com" },
      { id: "owner-grzegorz", fullName: "Grzegorz Brzęczyczykiewicz", phone: "+48 503 300 414" },
      { id: "owner-karolina", fullName: "Karolina Bąk", phone: "+48 504 450 550", email: "karolina.bak@example.com" },
      { id: "owner-ola", fullName: "Ola Majewska", phone: "+48 505 600 770", email: "ola.majewska@example.com" },
    ],
    pets: [
      { id: "pet-sheiba", ownerId: "owner-jan", name: "Sheba", sex: "female", breed: "Shiba inu", avatar: "🐕", careNotes: "Nie lubi suszarki przy głowie. Używać chłodniejszego nawiewu i robić krótkie przerwy." },
      { id: "pet-larry", ownerId: "owner-anna", name: "Larry", sex: "male", breed: "Cocker spaniel", avatar: "🐶", careNotes: "Spokojny, ale ma wrażliwe uszy. Dokładnie je osuszyć po kąpieli." },
      { id: "pet-siri", ownerId: "owner-anna", name: "Luna", sex: "female", breed: "Cocker spaniel", avatar: "🐶", careNotes: "Szampon hipoalergiczny. Boi się maszynki — zacząć od spokojnego czesania." },
      { id: "pet-lady", ownerId: "owner-grzegorz", name: "Lady", sex: "female", breed: "Labrador", avatar: "🐾", careNotes: "Wrażliwe tylne łapy. Pazurki obcinać powoli, najlepiej z krótką przerwą." },
      { id: "pet-dzony", ownerId: "owner-anna", name: "Fado", sex: "male", breed: "Mieszaniec", avatar: "🐕", careNotes: "Reaguje na inne psy w poczekalni. Przyjmować bezpośrednio po wejściu." },
      { id: "pet-ala", ownerId: "owner-karolina", name: "Tofik", sex: "male", breed: "Maltańczyk", avatar: "🐩", careNotes: "Łzawią mu oczy. Delikatnie oczyścić okolice pyska przed strzyżeniem." },
      { id: "pet-figa", ownerId: "owner-ola", name: "Idefix", sex: "male", breed: "Pudel", avatar: "🐩", careNotes: "Strzyc głównie nożyczkami. Właściciel nie chce bardzo krótkiej fryzury." },
    ],
    appointments: [
      appointment(now, "appointment-yesterday", "pet-figa", -1, 15, 0, 60, "confirmed", "haircut", 120, "Fryzura na misia, zostawić dłuższe uszy."),
      appointment(now, "appointment-sheiba", "pet-sheiba", 0, 9, 0, 60, "confirmed", "bath", 100, "Właściciel odbierze około 10 minut po zakończeniu."),
      appointment(now, "appointment-larry", "pet-larry", 0, 10, 30, 120, "pending", "haircut", 170, "Skrócić sierść na brzuchu i wyrównać pióra na łapach."),
      appointment(now, "appointment-lady", "pet-lady", 0, 14, 0, 30, "confirmed", "hygiene", 50, "Tylko pazurki, uszy i okolice łap."),
      appointment(now, "appointment-dzony", "pet-dzony", 1, 10, 30, 120, "pending", "bath-and-haircut", 190, "Pierwsza wizyta w salonie — zaplanować chwilę na oswojenie."),
      appointment(now, "appointment-ala", "pet-ala", 1, 13, 30, 60, "pending", "haircut", 130, "Nie skracać mocno sierści na ogonie."),
      appointment(now, "appointment-siri", "pet-siri", 2, 10, 30, 120, "pending", "bath-and-haircut", 180, "Proszę zadzwonić 15 minut przed wizytą."),
      appointment(now, "appointment-figa-2", "pet-figa", 2, 14, 0, 60, "confirmed", "bath", 90, "Użyć odżywki ułatwiającej rozczesywanie."),
      appointment(now, "appointment-larry-2", "pet-larry", 3, 9, 30, 90, "pending", "deshedding", 140, "Mocniej wyczesać podszerstek na grzbiecie."),
      appointment(now, "appointment-sheiba-2", "pet-sheiba", 3, 12, 0, 60, "pending", "other", 90, "Sprawdzić opuszki i skrócić sierść między palcami.", "Pielęgnacja łap"),
    ],
  };
}
